import React, { Component } from "react";
import { formatoSeparadorMiles, formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'

const tipoObligacion = {
  aporte: "APORTE",
  solidaridad: "SOLIDARIDAD"
};

export default class SeleccionImportePago extends Component {

  constructor(props) {
    super(props);
  };
  componentDidMount() {

  }

  obtenerMontoPagoMinimo() {
    if (this.props.datos.length === 0)
      return formatoSeparadorMilesValue(null);
    return formatoSeparadorMilesValue(this.props.datos[0].pagoMinimo);
  }

  obtenerSaldoMora() {
    return this.props.saldoMora;
  }

  obtenerDeudaTotal() {
    if (this.props.datos.length === 0)
      return formatoSeparadorMilesValue(null);
    return formatoSeparadorMilesValue(this.props.datos[0].saldoCierre);
  }

  obtenerDeudaAFecha() {
    if (this.props.datos.length === 0)
      return formatoSeparadorMilesValue(null);
    return formatoSeparadorMilesValue(this.props.datos[0].saldoAyer);
  }

  insertarPagoMinimo() {
    var valor = this.obtenerMontoPagoMinimo()
    document.getElementById('importe_pagar').value = valor
    this.props.rptRespuesta(valor)
  }
  insertarSaldoMora() {
    var valor = this.obtenerSaldoMora()
    document.getElementById('importe_pagar').value = valor
    this.props.rptRespuesta(valor)
  }
  insertarDeudaTotal() {
    var valor = this.obtenerDeudaTotal()
    document.getElementById('importe_pagar').value = valor
    this.props.rptRespuesta(valor)
  }
  insertarDeudaAFecha() {
    var valor = this.obtenerDeudaAFecha()
    document.getElementById('importe_pagar').value = valor
    this.props.rptRespuesta(valor)
  }



  render() {
    
    return (
      <div className="form-group">
        <div className="row">
          <div className="col-md-5">
            <label className="input-label-bold">Ingrese el Importe a Pagar *</label>
            <input type="text" id="importe_pagar" onKeyUp={formatoSeparadorMiles} maxLength="19" className="form-control input-box" onChange={(e) => this.props.rptRespuesta(e.target.value)}/>
          </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-3">
            <button className="btn btn-cu-largo-primary" onClick={() => this.insertarPagoMinimo()}>Monto de Pago Mínimo: {this.obtenerMontoPagoMinimo()} GS.</button>
            </div>
            <div className="col-lg-3 col-md-3">
            <button className="btn btn-cu-largo-primary" onClick={() => this.insertarSaldoMora()}>Saldo en Mora: {this.obtenerSaldoMora()} GS.</button>
            </div>
            <div className="col-lg-3 col-md-3">
            <button className="btn btn-cu-largo-primary" onClick={() => this.insertarDeudaAFecha()}>Deuda Total al Día de Ayer: {this.obtenerDeudaAFecha()} GS.</button>

            </div>
            <div className="col-lg-3 col-md-3">
            <button className="btn btn-cu-largo-primary" onClick={() => this.insertarDeudaTotal()}>Deuda Total al Cierre: {this.obtenerDeudaTotal()} GS.</button>

            </div>
          </div>
      </div>
    );
  }
}

